export default "__VITE_ASSET__5f29b45a__"